module.exports = __webpack_public_path__ + "img/s-eyes.ae77fc56.svg";